import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    categoryReset: null,
    productReset: null,
    categorySyncSuccess: null,
    productSyncSuccess: null,
    productStatus: null,
    categoryStatus: null,
    syncError:null
}


export const productResetById = createAsyncThunk("productResetById", async (data) => {
    try {
        const response = await fetch(`/api/resetProductById`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            throw new Error('Failed to reset product');
        }
        return await response.json();
        // return response;
    } catch (error) {
        throw new Error('Failed to reset product', error);
    }
});


export const productResetBySku = createAsyncThunk("productResetBySku", async (data) => {
    try {
        const response = await fetch(`/api/resetProductBySku`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            throw new Error('Failed to reset product');
        }
        return await response.json();
        // return response;
    } catch (error) {
        throw new Error('Failed to reset product', error);
    }
});


export const categoriesReset = createAsyncThunk("categoriesReset", async (data) => {
    try {
        const response = await fetch(`/api/resetCategories`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        })
        if (!response.ok) {
            throw new Error('Failed to reset Categories');
        }
        return await response.json();
        // return response;
    } catch (error) {
        throw new Error('Failed to reset Categories', error);
    }
});

// Thunk to reset productStatus after a delay
export const resetProductStatusAfterDelay = createAsyncThunk(
    'syncData/resetProductStatusAfterDelay',
    async (_, { dispatch }) => {
        await new Promise((resolve) => setTimeout(resolve, 2000)); // Wait for 2 seconds
        dispatch(clearProductStatus());
    }
);


const syncSlice = createSlice({
    name: "syncData",
    initialState,
    reducers: {
        clearProductStatus: (state) => {
            state.productReset = null;
        },
        clearCategoryStatus: (state) => {
            state.categoryReset = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(productResetById.pending, (state) => {
            state.productStatus = "Product Reset Inprogress"
            state.productReset = "inprogress"
            state.productSyncSuccess = null;
        });
        builder.addCase(productResetById.fulfilled, (state, action) => {
            state.productStatus = "Product Reset Completed"
            state.productReset = action.payload.data
        });
        builder.addCase(productResetById.rejected, (state) => {
            state.productStatus = "Product Reset Failed"
            state.productReset = "failed"
        });
        builder.addCase(productResetBySku.pending, (state) => {
            state.productStatus = "Product Reset Inprogress"
            state.productReset = "inprogress"
            state.productSyncSuccess = null;
            state.syncError = null;
        });
        builder.addCase(productResetBySku.fulfilled, (state, action) => {
            state.productStatus = "Product Reset Completed"
            state.productReset = action.payload.data
        });
        builder.addCase(productResetBySku.rejected, (state) => {
            state.productStatus = "Product Reset Failed"
            state.productReset = "failed"
        });
        builder.addCase(categoriesReset.pending, (state) => {
            state.categoryStatus = "Categories Reset Inprogress"
            state.categoryReset = "inprogress"
            state.categorySyncSuccess = null;
            state.syncError = null;
        });
        builder.addCase(categoriesReset.fulfilled, (state, action) => {
            state.categoryStatus = "Categories Reset Completed"
            state.categoryReset = action.payload.data
        });
        builder.addCase(categoriesReset.rejected, (state) => {
            state.categoryStatus = "Categories Reset Failed"
            state.categoryReset = "failed"
        });
    }
})

export const { clearProductStatus, clearCategoryStatus } = syncSlice.actions;
export default syncSlice.reducer